import PropTypes from 'prop-types';
import { Typography, Card, Divider, IconButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';

const CampaignTotal = (props) => {
  const theme = useTheme();
  const { occupationAndSource, professions } = props;
  const [open, setOpen] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (professions !== undefined) {
      if (professions.length > 0) {
        const tempRows = [];
        const total = { id: 1000, name: 'Total' };
        professions.forEach((prof) => {
          total[prof.profession] = { treated: { treated: 0 }, general: 0 };
        });
        let subTotalHRowGeneral = 0;
        let subTotalHRowTreated = 0;
        
        Object.keys(occupationAndSource).forEach((source) => {
          let row = { id: source, name: source };
          const totalHRow = { general: 0, treated: 0 };
          professions.forEach((profession) => {
            row[profession.profession] = occupationAndSource[source][profession.profession];
            total[profession.profession].general += occupationAndSource[source][profession.profession].general;
            total[profession.profession].treated.treated += occupationAndSource[source][profession.profession].treated.treated;
            totalHRow.general += occupationAndSource[source][profession.profession].general;
            totalHRow.treated += occupationAndSource[source][profession.profession].treated.treated;
          });
          subTotalHRowGeneral += totalHRow.general;
          subTotalHRowTreated += totalHRow.treated;
          
          // partie historique
          const historic = {};
          Object.keys(occupationAndSource[source].historique).forEach((date) => {
            historic[date] = occupationAndSource[source]['historique'][date];
            let totalTreated = 0;
            let totalProspects = 0;
            Object.keys(occupationAndSource[source]['historique'][date]).forEach((data) => {
              totalTreated += occupationAndSource[source]['historique'][date][data].general;
              totalProspects += occupationAndSource[source]['historique'][date][data].treated.treated;
            });
            historic[date].total = { treated: { treated: totalProspects }, general: totalTreated };
          });

          row = { ...row, totalH: totalHRow, historic };
          tempRows.push(row);
        });
        total.totalH = { general: subTotalHRowGeneral, treated: subTotalHRowTreated };
        tempRows.push(total);

        setRows(tempRows);
      }
      const tempOpen = [];
      Object.keys(occupationAndSource).forEach(() => tempOpen.push(false));
      tempOpen.push(false);
      setOpen(tempOpen);
    }
  }, [professions, occupationAndSource]);

  const handleOpen = (index) => {
    const tempOpen = [...open];
    tempOpen[index] = !tempOpen[index];
    setOpen(tempOpen);
  };

  return (
    <Card
      sx={{
        borderRadius: '24px',
        boxShadow: '0 4px 18px 0 rgba(0,0,0,0.03)',
        border: '1px solid',
        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255,255,255,0.08)',
        overflow: 'hidden'
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ p: 2.5, fontWeight: 700, color: theme.palette.text.primary }}
      >
        Nombre de prospects par profession et par source
      </Typography>
      <Divider />
      <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent' }}>
        <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
          <TableHead
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)',
              borderBottom: `2px solid ${theme.palette.divider}`
            }}
          >
            <TableRow>
              <TableCell sx={{ width: 60 }} />
              <TableCell
                sx={{
                  width: 200,
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Nom
              </TableCell>
              {professions.map((profession) => (
                <TableCell
                  key={profession.profession}
                  align="right"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                    py: 2,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.5px'
                  }}
                >
                  {profession.profession}
                </TableCell>
              ))}
              <TableCell
                align="right"
                sx={{
                  fontWeight: 700,
                  color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                  py: 2,
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  letterSpacing: '0.5px'
                }}
              >
                Total
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <React.Fragment key={row.name || row.id}>
                <TableRow
                  sx={{
                    '& > *': { borderBottom: 'unset' },
                    transition: 'background-color 0.2s ease',
                    backgroundColor: row.name === 'Total' ? (theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)') : 'inherit',
                    '&:hover': {
                      backgroundColor: row.name === 'Total' ? '' : (theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.02)' : 'rgba(255, 255, 255, 0.02)')
                    }
                  }}
                >
                  <TableCell sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleOpen(index)}
                    >
                      {open[index] && row.name !== 'Total' ? <KeyboardArrowUpIcon /> : !open[index] && row.name !== 'Total' ? <KeyboardArrowDownIcon /> : ''}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ py: 1.5, borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                  >
                    <Typography
                      sx={{
                        fontWeight: row.name === 'Total' || open[index] ? 700 : 500,
                        fontSize: open[index] && row.name !== 'Total' ? '1.1rem' : '0.875rem',
                        color: theme.palette.text.primary
                      }}
                    >
                      {row.name}
                    </Typography>
                  </TableCell>
                  {professions.map((profession) => {
                    const isCompleted = row[profession.profession].treated.treated === row[profession.profession].general && row[profession.profession].general > 0;
                    return (
                      <TableCell
                        key={profession.profession}
                        align="right"
                        sx={{
                          py: 1.5,
                          fontWeight: row.name === 'Total' ? 700 : 500,
                          borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: row.name === 'Total' ? 700 : 500,
                            color: isCompleted ? theme.palette.success.main : theme.palette.text.primary
                          }}
                        >
                          {`${row[profession.profession].treated === null ? 0 : row[profession.profession].treated.treated} (${row[profession.profession].general})`}
                        </Typography>
                      </TableCell>
                    );
                  })}
                  <TableCell
                    align="right"
                    sx={{
                      py: 1.5,
                      fontWeight: 700,
                      borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)'
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 700,
                        color: row.totalH.treated === row.totalH.general && row.totalH.general > 0 ? theme.palette.success.main : theme.palette.text.primary
                      }}
                    >
                      {`${row.totalH.treated === undefined ? 0 : row.totalH.treated} (${row.totalH === undefined ? 0 : row.totalH.general})`}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  {row.name !== 'Total' && (
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={professions.length + 3}
                      sx={{ borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)' }}
                    >
                      <Collapse
                        in={open[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ margin: 2, p: 2, borderRadius: '16px', border: '1px solid', borderColor: theme.palette.divider, backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.01)' }}>
                          <Typography
                            variant="subtitle2"
                            gutterBottom
                            component="div"
                            sx={{ fontWeight: 700, mb: 2, color: theme.palette.primary.main }}
                          >
                            Historique des réinjections
                          </Typography>
                          <Table size="small" aria-label="purchases">
                            <TableHead
                              sx={{
                                backgroundColor: theme.palette.mode === 'light' ? '#fff' : 'rgba(0,0,0,0.1)',
                                borderBottom: `2px solid ${theme.palette.divider}`
                              }}
                            >
                              <TableRow>
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Niveau de réinjection
                                </TableCell>
                                {professions.map((profession) => (
                                  <TableCell
                                    key={profession.profession}
                                    align="right"
                                    sx={{
                                      fontWeight: 700,
                                      color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                      fontSize: '0.75rem'
                                    }}
                                  >
                                    {profession.profession}
                                  </TableCell>
                                ))}
                                <TableCell
                                  align="right"
                                  sx={{
                                    fontWeight: 700,
                                    color: theme.palette.mode === 'light' ? '#475569' : '#94a3b8',
                                    fontSize: '0.75rem'
                                  }}
                                >
                                  Total
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {row.historic !== undefined && (
                                Object.keys(row.historic).map((histoData) => (
                                  <TableRow key={histoData} hover>
                                    <TableCell align="right" sx={{ fontWeight: 600, color: theme.palette.text.secondary }}>
                                      {histoData}
                                    </TableCell>
                                    {Object.keys(row.historic[histoData]).map((profession) => (
                                      <TableCell key={profession} align="right" sx={{ color: theme.palette.text.secondary }}>
                                        {`${row.historic[histoData][profession] === undefined || row.historic[histoData][profession].treated === null ? 0 : row.historic[histoData][profession].treated.treated} (${row.historic[histoData][profession].general})`}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                ))
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </Collapse>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

CampaignTotal.propTypes = {
  occupationAndSource: PropTypes.object.isRequired,
  professions: PropTypes.array.isRequired,
};

export default CampaignTotal;
